import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'slick-carousel';
import 'social-likes';
import Cookies from 'js-cookie';


$(() => {
	svg4everybody();
});

(function (pType) {
	$(function () {

		const $window = $(window);

		window.sys = {};

		window.sys.checkIsDesktop = function () {
			return $window.width() > 1160;
		};
		window.sys.checkIsTablet = function () {
			return $window.width() > 800 && $window.width() <= 1160;
		};
		window.sys.checkIsMobile = function () {
			return $window.width() <= 800;
		};

		// MAIN PAGE SLIDERS
		(function () {
			if ($('.main-slider_list').length) {
				$('.main-slider_list').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: !window.sys.checkIsMobile(),

					prevArrow: $('.main-slider_container .slider-controls_arrow_prev'),
					nextArrow: $('.main-slider_container .slider-controls_arrow_next'),
					appendDots: $('.main-slider_container .slider-controls_dots_container'),
					dotsClass: 'slider-controls_dots'
				});

				$('.main-slider_list').on('afterChange', function (event, slick, currentSlide) {
					const $slick = $(this).closest('.main-slider_list');
					const $slide = $slick.find('.slick-slide.slick-current.slick-active');
					if ($slide.length) {
						$slick.closest('.main-slider_wrapper').find('.main-slider_wrapper_bg').css({
							'background-image': 'url(' + $slide.find('.main-slider_item_image img').prop('src') + ')'
						});
					}
				});
			}
		})();

		// SPOILER BLOCKS
		(function () {
			$('.block_spoiler').each(function (index, element) {
				const $element = $(element);
				$element.children().last().hide();
				$element.children().first().click(function () {
					$element.toggleClass('open');
					$element.children().last().slideToggle();
					return false;
				});
			});
		})();

		// SELECT LINK IN SHARE WIDGET
		(function () {
			let focusedElement;
			$(document).on('focus', '.info-page_share_url input', function () {
				if (focusedElement === this) {
					return;
				}
				focusedElement = this;
				setTimeout(function () { focusedElement.select(); }, 100);
			}).on('focusout', '.info-page_share_url input', function () {
				focusedElement = null;
			});
		})();

		// INFO PAGE SLIDERS
		(function () {
			if ($('.info-slider_list').length) {
				$('.info-slider_list').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					arrows: !window.sys.checkIsMobile(),

					prevArrow: $('.info-slider_container .slider-controls_arrow_prev'),
					nextArrow: $('.info-slider_container .slider-controls_arrow_next'),
					appendDots: $('.info-slider_container .slider-controls_dots_container'),
					dotsClass: 'slider-controls_dots'
				});
			}
		})();

		// INFO PAGE ACTIONS
		(function () {
			$('.handler-copy-share-link').click(function () {
				if (navigator.clipboard) {
					navigator.clipboard.writeText($(this).prev().val());
				}
				return false;
			});
			$('.handler-go-back').click(function () {
				window.history.back();
				return false;
			});
		})();



		// MOBILE
		(function () {
			$('.handler-mobile-menu-open').click(function () {
				const $this = $(this);
				$this.closest('.header_control').addClass('_menu_open');
				$('.header_bottom').slideDown(function () {});
				return false;
			});
			$('.handler-mobile-menu-close').click(function () {
				const $this = $(this);
				$('.header_bottom').slideUp(function () {
					$this.closest('.header_control').removeClass('_menu_open');
				});
				return false;
			});
			$('.handler-mobile-profile').click(function () {
				if ($('.__meta_user_profile').length) {
					return true;
				}

				sendRequest('',{
					'action':'fe_login_form'
				});

				return false;
			});
		})();

		/** *****************************************/
	});
})('DEBUG');



// WEBPACK FOOTER //
// ./app/scripts/app.js